import { useCallback } from "react";
import { isFunction } from "lodash";
import { noop } from "lodash";
import { t } from "@/i18n-js/instance";
import { Filter, InputFilter, useFilterUrl } from "@circle-react-shared/Filter";

const localeRoot =
  "settings.paywalls_admin_dashboard.filters.community_member_billing_info_business_name";

export interface CommunityMemberBillingInfoBusinessNameFilterProps {
  changeUrl?: boolean;
  isInitialOpen?: boolean;
  onApply?: (value: string) => void;
  value?: string;
}

export const CommunityMemberBillingInfoBusinessNameFilter = ({
  isInitialOpen,
  onApply,
  changeUrl = true,
  value,
}: CommunityMemberBillingInfoBusinessNameFilterProps) => {
  const { queryParams, updateUrl } = useFilterUrl();
  const businessName =
    value ?? queryParams.community_member_billing_info_business_name;

  const handleApply = useCallback(
    (filterValue: string) => {
      updateUrl("page", 1);
      changeUrl &&
        updateUrl("community_member_billing_info_business_name", filterValue);
      if (isFunction(onApply)) {
        onApply(filterValue);
      }
    },
    [changeUrl, updateUrl, onApply],
  );

  return (
    <Filter
      chip={t([localeRoot, "chip"])}
      title={t([localeRoot, "title"])}
      selectedText={businessName}
      isInitialOpen={isInitialOpen}
      onApply={handleApply}
      shouldShowRemoveButton
    >
      <InputFilter
        name="community_member_billing_info_business_name"
        placeholder={t([localeRoot, "placeholder"])}
        defaultValue={businessName}
      />
    </Filter>
  );
};

export const filterProperties = {
  name: "community_member_billing_info_business_name",
  filterKeys: ["community_member_billing_info_business_name"],
  component: (prop: CommunityMemberBillingInfoBusinessNameFilterProps) => (
    <CommunityMemberBillingInfoBusinessNameFilter {...prop} onApply={noop} />
  ),
  label: t([localeRoot, "chip"]),
};
